
import { Placement } from '@post-office/placements-frontend/jira-reports-agent-roi-spotlight';
export default Placement;
